let savedCallback = null

const bind = (callback) => {
  if (!callback || typeof callback !== 'function') { throw new Error('Please provide correct callback') }

  if (savedCallback) { throw new Error("Can't bind more than one callback") }

  savedCallback = callback

  window.addEventListener('keypress', (ev) => {
    if (ev.key === 'Enter') {
      callback()
    }
  })
}

const unbind = () => {
  if (!savedCallback) { return }

  window.removeEventListener('keypress', savedCallback)

  savedCallback = null
}

export const enterKeyPressHolder = () => {
  return {
    bind,
    unbind
  }
}
